import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "acquaint-info-textbox-container" }

import { PropType } from "vue";
import { DxButton, DxTextBox } from "devextreme-vue/text-box";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'acquaint-info-box',
  props: {
  /**
   * The text content displayed within the component.
   * @type {string}
   * @required
   */
  text: {
    type: String,
    required: true,
  },
  /**
   * The width of the component, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * The label displayed for the control.
   * @type {string}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * The icon associated with the component.
   * @type {string}
   * @default ''
   */
  icon: {
    type: String,
    default: "",
  },
  /**
   * The icon associated with the component.
   * @type {string}
   * @default ''
   */
  secondIcon: {
    type: String,
    default: "",
  },
},
  emits: ["iconClicked", "secondIconClicked"],
  setup(__props, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DxTextBox), {
        value: __props.text,
        width: __props.width,
        "read-only": true
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            name: "second-info-box-icon",
            position: "after",
            options: {
            icon: props.secondIcon,
            stylingMode: 'text',
            type: 'dx-dropdowneditor-button',
            disabled: false,
            visible: props.secondIcon,
            onClick: () => emit('secondIconClicked'),
          }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxButton), {
            name: "first-info-box-icon",
            position: "after",
            options: {
            icon: props.icon,
            stylingMode: 'text',
            type: 'dx-dropdowneditor-button',
            disabled: false,
            visible: props.icon,
            onClick: () => emit('iconClicked'),
          }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["value", "width"])
    ])
  ]))
}
}

})